import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { UpdateShopMemberRoleDto } from "../generated/schema";
import useInvalidateTeamMembers from "./use-invalidate-team-members";

type UseUpdateTeamMemberRoleParams = {
	onSuccess?: () => void;
	onError?: () => void;
};

export default function useUpdateTeamMemberRole(
	shopId: string,
	userId: string,
	options?: UseUpdateTeamMemberRoleParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const mutation = $api.useMutation(
		"patch",
		"/shops/{shopId}/members/{userId}/role",
	);
	const invalidateShopMembers = useInvalidateTeamMembers(shopId);

	return useMutation({
		onSuccess: () => {
			invalidateShopMembers();
			successNotification();
			options?.onSuccess?.();
		},
		onError: () => {
			errorNotification();
			options?.onError?.();
		},
		mutationFn: async (requestBody: UpdateShopMemberRoleDto) => {
			return mutation.mutateAsync({
				params: { path: { userId, shopId } },
				body: {
					roleId:
						requestBody.roleId.toUpperCase() as UpdateShopMemberRoleDto["roleId"],
					storeId: requestBody.storeId,
				},
			});
		},
	});
}
